import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ion-padding custom-skeleton" }

import {
  IonItem, IonLabel, IonSkeletonText, IonThumbnail,
} from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListSkeletton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonItem), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonThumbnail), { slot: "start" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSkeletonText))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonLabel), null, {
          default: _withCtx(() => [
            _createElementVNode("h3", null, [
              _createVNode(_unref(IonSkeletonText), {
                animated: "",
                style: {"width":"80%"}
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_unref(IonSkeletonText), {
                animated: "",
                style: {"width":"30%"}
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonItem), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonThumbnail), { slot: "start" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSkeletonText))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonLabel), null, {
          default: _withCtx(() => [
            _createElementVNode("h3", null, [
              _createVNode(_unref(IonSkeletonText), {
                animated: "",
                style: {"width":"80%"}
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_unref(IonSkeletonText), {
                animated: "",
                style: {"width":"30%"}
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonItem), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonThumbnail), { slot: "start" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSkeletonText))
          ]),
          _: 1
        }),
        _createVNode(_unref(IonLabel), null, {
          default: _withCtx(() => [
            _createElementVNode("h3", null, [
              _createVNode(_unref(IonSkeletonText), {
                animated: "",
                style: {"width":"80%"}
              })
            ]),
            _createElementVNode("p", null, [
              _createVNode(_unref(IonSkeletonText), {
                animated: "",
                style: {"width":"30%"}
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})